import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // get key from URL
import axios from "axios";
import { Table, Spinner, Alert, Container } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Button, Col, FloatingLabel, Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./FamilyAssesmentStyling.css"

const AssesmentDashboardRecord = () => {
  const { key } = useParams(); // Example: verification-distributed
      const [families, setFamilies] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);

       const mockGroups = [
    {
      fsfid: "GRP001",
      beneficiaryName: "Sunrise Group",
      partner: "Mixed",
      debtLedger: "Monthly",
      status: "Karachi",
     
    },
    {
       fsfid: "GRP001",
      beneficiaryName: "Sunrise Group",
      partner: "Mixed",
      debtLedger: "Monthly",
      status: "Karachi",
     
    },
    {
       fsfid: "GRP001",
      beneficiaryName: "Sunrise Group",
      partner: "Mixed",
      debtLedger: "Monthly",
      status: "Karachi",
      
    },
  ];
const [groups,setGroups] = useState(mockGroups);

    // const navigate = useNavigate();
    // navigate('/group-list');

  const handleDetails = (e)=>{

    console.log("This is the detail page")


  }
  return (
<>


  <PageLayout>
    
       <Row>
         <Col xl={12}>
           <div className="mc-card">
             <div className="mc-breadcrumb">
               {/* <h3 className="mc-breadcrumb-title">  List of Families: {key.replaceAll("-", " ")}</h3> */}
               <ul className="mc-breadcrumb-list">
                 <li className="mc-breadcrumb-item">
                   <Link to="#" className="mc-breadcrumb-link"
                   style={{color:"#077834"}}>
                     {"home"}
                   </Link>
                 </li>
                 <li className="mc-breadcrumb-item">
                   <Link to="#" className="mc-breadcrumb-link"  style={{color:"#077834"}}>
                     {"assesment list"}
                   </Link>
                 </li>
                 <li className="mc-breadcrumb-item">{"Dashboard"}</li>
               </ul>
             </div>
           </div>
         </Col>
       </Row>
       <Container className="mt-4">
  <div style={{ overflowX: "auto" }}>
    <Table striped bordered hover>
      <thead className=""
      >
        <tr >
          <th>#</th>

          <th>FSF-ID</th>
          <th>BENEFICIARY</th>
          <th>PARTNER</th>
          <th>DEBT LEDGER</th>
          <th>STATUS</th>
         
          <th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
      {groups.map((group,index)=>(

        <tr key={group.groupCode}>
        <td>{index + 1}
           <a className="mc-round-avatar  xs" href="/"><img src="images/avatar/01.webp" alt="avatar" /></a>
           </td>
        <td>{group.fsfid}</td>
        <td>{group.beneficiaryName}</td>
        <td>{group.partner}</td>
        <td>{group.debtLedger}</td>
        <td>{group.status}</td>
        
        <td className="action-cell"><Link to="/person-report-page">
      <FontAwesomeIcon className="eye-icon" icon={faEye} size="lg"  />
    </Link>

</td>
        </tr>
     ) )}
      </tbody>
    </Table>
  </div>
</Container>

     </PageLayout>
</>  )
};

export default AssesmentDashboardRecord;
